function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTovala = function SvgTovala(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.863 23.316V1.174h2.924v19.553h11.086v2.589h-14.01Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m117.076 1.174-8.497 22.111h2.923l1.828-4.75h10.66l1.919 4.75h3.045l-8.619-22.111h-3.259Zm1.584 3.441-4.355 11.3h8.771l-4.416-11.3ZM162.121 1.143l-8.497 22.111h2.924l1.827-4.751h10.66l1.919 4.751H174l-8.62-22.111h-3.259Zm1.584 3.441-4.355 11.3h8.771l-4.416-11.3Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.465 23.376-8.42-22.233h3.143l6.863 18.365 6.833-18.365h3.081l-8.328 22.233h-3.172Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.657 12.229C63.803 3.092 70.417.828 73.705.838v2.437c-2.37.038-6.96 1.859-7.064 8.93-.103 7.074 4.608 8.924 7.064 8.977v2.498c-3.41-.01-10.195-2.314-10.048-11.451Zm10.049 8.953v2.498c3.41-.01 10.195-2.314 10.048-11.451C83.607 3.092 76.994.828 73.706.838v2.437h.091c2.342-.009 7.051 1.766 7.156 8.93.104 7.163-4.727 8.97-7.156 8.978l-.091-.001Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.143h7.492v7.492H0zM0 15.883h7.492v7.492H0zM14.741 1.143h7.492v7.492h-7.492zM14.741 15.883h7.492v7.492h-7.492zM40.63 3.763v-2.59h18v2.59h-7.432v19.553h-2.954V3.763h-7.615Z",
    fill: props.color,
    stroke: props.color
  })));
};
export default SvgTovala;